import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '@/locales';
import CompatibilityServices from '@/api/CompatibilityServices';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appConfig: [],
  },

  getters: {
    getSiteConfig(state) {
      return state.appConfig;
    },
  },

  mutations: {
    ADD_SITE_CONFIG(state, appConfig) {
      this.state.appConfig = appConfig;
    },
  },

  actions: {
    async getSiteConfig({ commit }) {
      try {
        let MyUrl = '';
        if (localStorage.getItem('app')) {
          MyUrl = localStorage.getItem('site_url');
        } else {
          MyUrl = window.location.origin;
          if (MyUrl.indexOf('myzone') < 0) {
            // MyUrl = 'http://myzonedev.airzonesl.es';
            MyUrl = 'https://myzone.airzone.es';
          }
        }
        const response = await CompatibilityServices.getDataSite(
          `${MyUrl}/soap.php?act=getDataSite`,
        );
        const langs = localStorage.getItem('app')
          ? localStorage.getItem('lang')
          : response.data.lang;
        i18n.locale = langs;

        commit('ADD_SITE_CONFIG', response.data);
      } catch (error) {
        throw error;
      }
    },
  },
});
